import { z } from 'zod';

export enum GenericMessageTypes {
  KYC_FAILED = 'KYC_FAILED',
  HANG_TIGHT = 'HANG_TIGHT', // TODO: Find a better name to describe this condition
  ONE_OF_US = 'ONE_OF_US',
  PREVIOUS_BUSINESS = 'PREVIOUS_BUSINESS',
  AUTHORIZED_USER_INVITE_CANCELED = 'AUTHORIZED_USER_INVITE_CANCELED',
  AUTHORIZED_USER_ALREADY_REGISTER = 'AUTHORIZED_USER_ALREADY_REGISTER',
}

export const genericMessageQueryParamsSchema = z.object({
  type: z.nativeEnum(GenericMessageTypes),
});
